import {handleActions, createAction} from 'redux-actions'
import {individualList} from "../entities/schema"
import {denormalize} from 'normalizr'
import createRemoteAction from './remote'
import queryString from "../functions/queryString";

export const clearResults = createAction("SEARCH_CLEAR");
export const setLimitExceeded = createAction("SEARCH_LIMIT_EXCEEDED");

export const search = createRemoteAction({
    type: 'SEARCH',
    url: params => 'individuals/search?'+ queryString(params),
    headers: {
        'Accept': 'application/ld+json',
        'X-Embed-Icons': 1,
    },
    schema: individualList,
});

const initialState = {
    fetching: false,
    error: null,
    ids: [],
    count: 0,
    page: 1,
    limitExceeded: null,
};

export default handleActions({
    [search.begin]: state => ({
        ...state,
        error: null,
        fetching: true,
    }),
    [search.request]: (state, action) => ({
        ...state,
        fetching: false,
        error: action.error ? action.payload.error : null,
        ids: action.error ? [] : action.payload.normalized.result,
        count: action.error ? 0 : action.payload.count,
        page: 1,
    }),
    [clearResults]: state => ({
        ...state,
        ids: [],
        count: 0,
    }),
    [setLimitExceeded]: (state, action) => ({
        ...state,
        limitExceeded: action.payload,
    }),
}, initialState);

export const getIsFetching = state => state.fetching;
export const getError = state => state.error;
export const getResults = (state, entities) => denormalize(state.ids, individualList, entities);
export const getResultCount = state => state.count;
export const getPage = state => state.page;
export const getLimitExceeded = state => state.limitExceeded;


// WEBPACK FOOTER //
// ./src/actions/search.js